module.exports = __webpack_public_path__ + "img/slide-1.74881752.jpg";